function getUrl(url, page) {
  if (url && page && page.isPreview() && /^\/[a-zA-Z0-9_].*/.test(url)) {
    return page.getUrl(url);
  }
  return url;
}
export {
  getUrl
};
//# sourceMappingURL=get-url.js.map
